import * as memberAPI from '@adobe/edex/frontend/api/member';
import { EdexAuth } from '@adobe/edex/ui/shared/config/auth';

const member = {
  namespaced: true,
  state: {
    member: null,
    loading: false,
  },
  mutations: {
    setMember: (state, data) => {
      state.member = data;
      state.loading = false;
    },
    logout: (state, data) => {
      localStorage.clear();
      state.member = null;
    },
    setLoading(state) {
      state.loading = true;
    },
  },
  actions: {
    async authenticate({ commit }) {
      const routeName = window.location.pathname;
      if (routeName === 'student/unsubscribe') {
        return false;
      }
      const { user } = await EdexAuth.getInstance().authenticate();
      if (user) {
        commit('setMember', user);
      }
      return !!user;
    },
    async self({ commit }) {
      commit('setLoading');
      const { data: member } = await memberAPI.self();
      commit('setMember', member);
      return member;
    },
  },
};

export default member;
